import { useDataGrid } from 'admin';
import type { Ticket } from 'api';
import React from 'react';
import { DataGrid } from 'ui';

import { useFindTicketsFilters } from '~/tickets/hooks/useFindTicketsFilters/useFindTicketsFilters';

import { columns } from './columns';

export const FindTicketsTable = () => {
  const permanent_filters = useFindTicketsFilters();
  const { dataGridProps } = useDataGrid({
    filters: {
      permanent: permanent_filters,
    },
    pagination: {
      mode: 'server',
    },
    resource: '/tickets/v1/find/',
    sorters: {
      mode: 'server',
    },
    syncWithLocation: false,
  });
  return (
    <DataGrid<Ticket>
      {...dataGridProps}
      showColumnVerticalBorder
      showCellVerticalBorder
      autoHeight
      density="standard"
      sx={{ overflowX: 'scroll' }}
      columns={columns}
      onRowClick={(params) => {
        window.open(params.row.external_link);
      }}
    />
  );
};
